// ASSETS

// STYLES
import {
  Bullet,
  ButtonContainer,
  CardContainer,
  ListContainer,
  ListItem,
  TextsContainer,
} from "./CookiesCardStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { IProps } from "./CookiesCardModel";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";

// REDUX

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import CustomText from "components/Atoms/CustomText/CustomText";

const CookiesCard = (props: IProps) => {
  // PROPERTIES
  const {
    id = 0,
    texts = [],
    title = "",
    list = [],
    hasButton = false,
    onClick = () => {},
  } = props;
  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  return (
    <CardContainer>
      {title && (
        <CustomText
          type={TextType.H2}
          text={t(title)}
          color={COLORS.RaisinBlack}
        />
      )}
      {texts.length > 0 && (
        <TextsContainer>
          {texts.map((text, index) => (
            <CustomText
              key={index}
              type={TextType.P2}
              text={t(text)}
              color={COLORS.RaisinBlack}
            />
          ))}
        </TextsContainer>
      )}
      {list.length > 0 && (
        <ListContainer>
          {list.map((item, index) => (
            <ListItem key={index}>
              <Bullet />
              <CustomText
                type={TextType.P2}
                text={item}
                color={COLORS.VividAuburn}
              />
            </ListItem>
          ))}
        </ListContainer>
      )}
      {hasButton && (
        <ButtonContainer>
          <ButtonAtom
            type={ButtonType.CookieButton}
            text={t("cookies.button")}
            onClick={onClick}
          />
        </ButtonContainer>
      )}
    </CardContainer>
  );
};

export default CookiesCard;
